import { NewbuildingContactsContainer } from './NewbuildingContactsContainer';

// eslint-disable-next-line import-x/no-default-export
export default NewbuildingContactsContainer;
